import Advanced from 'pages/profile/components/ProfileTabContent/Account/Advanced';
import InvestmentProfile from 'pages/profile/components/ProfileTabContent/Account/InvestmentProfile';
import PersonalInformation from 'pages/profile/components/ProfileTabContent/Account/PersonalInformation';
import BankAndTransfers from 'pages/profile/components/ProfileTabContent/Bank&Transfers';
import HelpAndSupport from 'pages/profile/components/ProfileTabContent/Help&Support';
import ProfileDocuments from 'pages/profile/components/ProfileTabContent/ProfileDocuments';
import PersonalInformationIcon from 'public/assets/icons/face_content.svg';
import MaintenanceIcon from 'public/assets/icons/maintenance.svg';
import InvestmentProfileIcon from 'public/assets/icons/money_dollar.svg';
import React from 'react';
import ResidentProfile from './components/ProfileTabContent/Account/ResidentProfile';

export enum PROFILE_TABS {
  ACCOUNT = 'Account',
  BANK_AND_TRANSFERS = 'Bank and Transfers',
  // DEVICE_AND_SECURITY = 'Device & Security',
  HELP_AND_SUPPORT = 'Support',
  // NOTIFICATION_PREFERENCES = 'Notification Preferences',
  Documents = 'Documents',
}

export type TAB_MENU_ITEM = {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  component: React.FC;
  className?: string;
  iconClassName?: string;
};

export const TABS_MENUS: {
  [key in PROFILE_TABS]: TAB_MENU_ITEM[];
} = {
  [PROFILE_TABS.ACCOUNT]: [
    {
      icon: PersonalInformationIcon,
      label: 'Personal Information',
      component: PersonalInformation,
    },
    {
      icon: InvestmentProfileIcon,
      label: 'Investment Profile',
      component: InvestmentProfile,
    },
    // {
    //   icon: BeneficiariesIcon,
    //   label: 'Beneficiaries',
    //   component: Beneficiaries,
    // },
    // {
    //   icon: TrustedContactIcon,
    //   label: 'Trusted Contact',
    //   component: TrustedContact,
    // },
    {
      icon: InvestmentProfileIcon,
      label: 'Resident Profile',
      component: ResidentProfile,
    },
    {
      icon: MaintenanceIcon,
      label: 'Advanced',
      component: Advanced,
    },
  ],
  [PROFILE_TABS.BANK_AND_TRANSFERS]: [
    {
      label: 'Bank and Transfers',
      component: BankAndTransfers,
    },
  ],
  // [PROFILE_TABS.DEVICE_AND_SECURITY]: [
  //   {
  //     label: 'Device and Security',
  //     component: DeviceAndSecurity,
  //   },
  // ],
  [PROFILE_TABS.HELP_AND_SUPPORT]: [
    {
      label: 'Help and Support',
      component: HelpAndSupport,
    },
  ],
  // [PROFILE_TABS.NOTIFICATION_PREFERENCES]: [
  //   {
  //     label: 'Notification Preferences',
  //     component: NotificationPreferences,
  //   },
  // ],
  [PROFILE_TABS.Documents]: [
    {
      label: 'Documents',
      component: ProfileDocuments,
    },
  ],
};
